<!-- MERK dersom du gjør endringer i hvilke formateringsvalg som vises som standard MÅ $mat-form-field-riktekst-redigering-min-bredde
-- i riktekst-redigering-mixins.scss oppdateres -->
<!-- menylinjen tegnes ikke ut dersom skjulMenylinje er satt, kontekstmenyen (tiptap-bubble-menu) vises fortsatt ved tekstmarkering -->
@if (!skjulMenylinje()) {
  <!-- lagt til (click) for å hindre at click bobler opp og trigger potensielt uønsket handling (for å være på den sikre siden)-->
  <div class="formateringsvalg"
       [class.viser-alle]="viserAlleFormateringsvalg()"
       [class.formateringsverktøy-er-aktivt]="formateringsverktoeyErAktivt()"
       (click)="$event.stopPropagation();"
       data-testid="formateringsvalg"
       #formateringsvalg>
    <ng-container *ngTemplateOutlet="basalTekstformatering"/>
    <span class="gruppe">
      <button mat-icon-button type="button"
              [class.aktiv]="tiptapEditor.editor.isActive('orderedList')"
              (click)="tiptapEditor.editor.chain().focus().toggleOrderedList().run()"
              matTooltip="{{'Ordnet liste' | translate}}">
        <mat-icon>format_list_numbered</mat-icon>
      </button>
      <button mat-icon-button type="button"
              [class.aktiv]="tiptapEditor.editor.isActive('bulletList')"
              (click)="tiptapEditor.editor.chain().focus().toggleBulletList().run()"
              matTooltip="{{'Punktliste' | translate}}">
        <mat-icon>format_list_bulleted</mat-icon>
      </button>
    </span>

    <span class="gruppe">
      <ng-container *ngTemplateOutlet="lenke"/>

      <button mat-icon-button type="button"
              [nedtrekksmenyTriggerFor]="nyTabellMeny"
              [nedtrekksmenyKonfigurasjon]="nyTabellMenyKonfigurasjon"
              (nedtrekksmenyAapnet)="formateringsverktoeyAktivert(true)"
              (nedtrekksmenyLukket)="formateringsverktoeyAktivert(false)"
              matTooltip="{{'Sett inn tabell' | translate}}"
              data-test-id="aktiver">
        <mat-icon>table</mat-icon>
      </button>
      <nedtrekksmeny #nyTabellMeny>
        <riktekst-redigering-tabellstoerrelse-velger (vedStoerrelseValgt)="this.tiptapEditor.opprettTabell($event);"/>
      </nedtrekksmeny>
    </span>

    <span class="gruppe">
      <button mat-icon-button type="button"
              (click)="this.tiptapEditor.fjernFormatering();"
              matTooltip="{{'Fjern formatering' | translate}}">
        <mat-icon>format_clear</mat-icon>
      </button>
    </span>

    @if (!erFullskjermvisning() || !visAlleFormateringsvalg()) {
      <span class="gruppe">
        @if (!erFullskjermvisning()) {
          <button mat-icon-button type="button"
                  (click)="aapneIFullskjermvisning()"
                  matTooltip="{{'Gå til fullskjermvisning' | translate}}"
                  data-testid="åpne-i-fullskjermvisning-knapp">
            <mat-icon>open_in_full</mat-icon>
          </button>
        }

        @if (!visAlleFormateringsvalg()) {
          <button mat-icon-button type="button"
                  (click)="endreVisAlleFormateringsvalg()"
                  matTooltip="{{'Vis flere formateringsvalg' | translate}}">
            <mat-icon>more_horiz</mat-icon>
          </button>
        }
      </span>
    }

    @if (viserAlleFormateringsvalg()) {
      <span class="gruppe">
        <button mat-icon-button type="button"
                [nedtrekksmenyTriggerFor]="tekstjusteringMeny"
                (nedtrekksmenyAapnet)="formateringsverktoeyAktivert(true)"
                (nedtrekksmenyLukket)="formateringsverktoeyAktivert(false)"
                matTooltip="{{'Tekstjustering' | translate}}"
                data-test-id="aktiver">
          <mat-icon>format_align_left</mat-icon>
        </button>
        <nedtrekksmeny class="tekstjustering" #tekstjusteringMeny>
          <button mat-icon-button type="button" [class.aktiv]="tiptapEditor.editor.isActive({textAlign:'left'})"
                  (click)="this.tiptapEditor.toggleTekstjustering('left');">
            <mat-icon>format_align_left</mat-icon>
          </button>
          <button mat-icon-button type="button" [class.aktiv]="tiptapEditor.editor.isActive({textAlign:'center'})"
                  (click)="this.tiptapEditor.toggleTekstjustering('center');">
            <mat-icon>format_align_center</mat-icon>
          </button>
          <button mat-icon-button type="button" [class.aktiv]="tiptapEditor.editor.isActive({textAlign:'right'})"
                  (click)="this.tiptapEditor.toggleTekstjustering('right');">
            <mat-icon>format_align_right</mat-icon>
          </button>
        </nedtrekksmeny>
        <button mat-icon-button type="button"
                (click)="tiptapEditor.editor.chain().focus().indent().run()"
                matTooltip="{{'Øk innrykk' | translate}}">
          <mat-icon>format_indent_increase</mat-icon>
        </button>
        <button mat-icon-button type="button"
                (click)="tiptapEditor.editor.chain().focus().outdent().run()"
                matTooltip="{{'Reduser innrykk' | translate}}">
          <mat-icon>format_indent_decrease</mat-icon>
        </button>
      </span>

      <span class="gruppe">
        <riktekst-redigering-overskrift-velger (aktivert)="formateringsverktoeyAktivert($event)" matTooltip="{{'Velg overskriftsnivå' | translate}}"/>
        <riktekst-redigering-font-stoerrelse-velger (aktivert)="formateringsverktoeyAktivert($event)" matTooltip="{{'Velg fontstørrelse' | translate}}"/>
        <riktekst-redigering-font-type-velger (aktivert)="formateringsverktoeyAktivert($event)" matTooltip="{{'Velg fonttype' | translate}}"/>
        <button mat-icon-button
                type="button"
                class="tekstfarge"
                [style.color]="tekstfargeKontroll.value"
                [formControl]="tekstfargeKontroll"
                ngx-colors-trigger
                (open)="tekstfargevelgerAktivert()"
                (close)="formateringsverktoeyAktivert(false)"
                format="hex"
                colorPickerControls="no-alpha"
                acceptLabel="{{'Velg' | translate}}"
                cancelLabel="{{'Avbryt' | translate}}"
                matTooltip="{{'Sett tekstfarge' | translate}}"
                #tekstfargevelger>
          <mat-icon>format_color_text</mat-icon>
        </button>
        <button mat-icon-button
                type="button"
                class="bakgrunnsfarge"
                [style.color]="bakgrunnsfargeKontroll.value"
                [formControl]="bakgrunnsfargeKontroll"
                ngx-colors-trigger
                (open)="bakgrunnsfargevelgerAktivert()"
                (close)="formateringsverktoeyAktivert(false)"
                format="hex"
                colorPickerControls="no-alpha"
                acceptLabel="{{'Velg' | translate}}"
                cancelLabel="{{'Avbryt' | translate}}"
                matTooltip="{{'Sett bakgrunnsfarge' | translate}}"
                #bakgrunnsfargevelger>
          <mat-icon>format_color_fill</mat-icon>
        </button>
      </span>

      @if (innholdBrukesIPdf()) {
        <button mat-icon-button type="button"
                [class.aktiv]="tiptapEditor.editor.isActive('sideSkift')"
                (click)="tiptapEditor.editor.chain().focus().leggTilSideSkift().run()"
                [disabled]="!tiptapEditor.editor.can().leggTilSideSkift()"
                matTooltip="{{'Sett inn sideskift (vises i genererte PDF-dokumenter)' | translate}}">
          <mat-icon>insert_page_break</mat-icon>
        </button>
      }

      <span class="gruppe">
        <button mat-icon-button type="button"
                (click)="tiptapEditor.editor.chain().focus().undo().run()"
                [disabled]="!tiptapEditor.editor.can().undo()"
                matTooltip="{{'Angre siste endring' | translate}}">
          <mat-icon>undo</mat-icon>
        </button>
        <button mat-icon-button type="button"
                (click)="tiptapEditor.editor.chain().focus().redo().run()"
                [disabled]="!tiptapEditor.editor.can().redo()"
                matTooltip="{{'Utfør likevel' | translate}}">
          <mat-icon>redo</mat-icon>
        </button>
      </span>

    }

    @if (erFullskjermvisning()) {
      <!-- vi har ikke noen egen stiling på .lukk-fullskjermvisning-gruppe her, men RiktekstRedigeringFullskjermmodalKomponent bruker denne klassen for å skjule gruppen dersom dialogen vises med tittel -->
      <span class="gruppe lukk-fullskjermvisning-gruppe">
        <button mat-stroked-button
                type="button"
                (click)="lukkFullskjermvisning()"
                class="lukk-fullskjermvisning"
                matTooltip="{{'Lukk fullskjermvisning' | translate}}"
                data-testid="lukk-fullskjermvisning-knapp">
          <mat-icon>close_fullscreen</mat-icon>
            {{'Minimer'|translate}}
        </button>
      </span>
    }

  </div>
}

<!-- (click)=giEditorFokus() er nødvendig da selve redigeringsfeltet kan være smalere enn riktekst-redigering komponenten og vi ønsker at redigeringsfeltet skal få fokus selvom bruker klikker utenfor dette feltet -->
<!-- vi må vente til editor er initialisert før vi sender data til den -->
@if(tiptapEditor.editorInitialisert()) {
  <tiptap-editor [editor]="tiptapEditor.editor"
                 [formControl]="skjemakontroll()"
                 [class.pdf-innhold]="innholdBrukesIPdf()"
                 [class.vis-stiplet-maks-innhold-bredde]="innholdBrukesIPdf() && redigeringsfeltErBredereEnnMaksPdfBredde() && focusedSomSignal()"
                 (click)="giEditorFokus($event)"
                 (paste)="stoppPropageringAvPasteEvent($event)"
                 data-testid="tiptap-editor"/>

  <!-- kontekstmeny som vises når tekst er markert -->
  <tiptap-bubble-menu [editor]="tiptapEditor.editor" [shouldShow]="skalKontekstmenyTekstformateringVises"
                      [tippyOptions]="{placement: 'bottom'}">
    <!-- lagt til (click) for å hindre at click bobler opp og trigger potensielt uønsket handling (for å være på den sikre siden)-->
    <div class="kontekstmeny" (click)="$event.stopPropagation();">
      <ng-container *ngTemplateOutlet="basalTekstformatering"/>
      <span class="gruppe">
        <ng-container *ngTemplateOutlet="lenke"/>
      </span>
    </div>
  </tiptap-bubble-menu>
}


<ng-template #basalTekstformatering>
  <span class="gruppe">
    <button mat-icon-button type="button"
            [class.aktiv]="tiptapEditor.editor.isActive('bold')"
            (click)="tiptapEditor.editor.chain().focus().toggleBold().run()"
            matTooltip="{{'Fet skrift' | translate}}">
      <mat-icon>format_bold</mat-icon>
    </button>
    <button mat-icon-button type="button"
            [class.aktiv]="tiptapEditor.editor.isActive('italic')"
            (click)="tiptapEditor.editor.chain().focus().toggleItalic().run()"
            matTooltip="{{'Kursiv skrift' | translate}}">
      <mat-icon>format_italic</mat-icon>
    </button>
    <button mat-icon-button type="button"
            [class.aktiv]="tiptapEditor.editor.isActive('underline')"
            (click)="tiptapEditor.editor.chain().focus().toggleUnderline().run()"
            matTooltip="{{'Understreket skrift' | translate}}">
      <mat-icon>format_underlined</mat-icon>
    </button>
    <button mat-icon-button type="button"
            [class.aktiv]="tiptapEditor.editor.isActive('strike')"
            (click)="tiptapEditor.editor.chain().focus().toggleStrike().run()"
            matTooltip="{{'Gjennomstreket skrift' | translate}}">
      <mat-icon>format_strikethrough</mat-icon>
    </button>
  </span>
</ng-template>

<ng-template #lenke>
  <button mat-icon-button type="button"
          (click)="tiptapEditor.editor.chain().lagNyLenkeMedTomHref().run()"
          [attr.aria-label]="'Sett inn Lenke' | translate"
          matTooltip="{{'Sett inn Lenke' | translate}}">
    <mat-icon>link</mat-icon>
  </button>
</ng-template>
